export const restrictedPhotoWarningPath = '/restricted-photo-warning'
export const restrictedPhotoWarningFullPath = `${restrictedPhotoWarningPath}/:messageId`

export type RestrictedPhotoWarningModalRouteParams = {
  messageId: string
}
